// TODO - Type 'any' needs to be fixed.
import Dialog from "@mui/material/Dialog";
import isPast from "date-fns/isPast";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import DialogWrapper from "../../../../../design/dialog-wrapper";
import NewShiftDialogForm from "./new-shift-dialog-form";
import PastShiftDialog from "./past-shift";

type NewShiftDialogProps = {
	handleClose: (() => void) | undefined;
	open: boolean;
	draftShiftDate: Date;
	isShiftSwap?: boolean;
	requestComponent?: any;
	isShiftCoverage?: boolean;
};

const NewShiftDialog: React.FC<NewShiftDialogProps> = ({
	handleClose,
	open,
	draftShiftDate,
	isShiftSwap,
	requestComponent,
	isShiftCoverage,
}) => {
	const { t } = useTranslation();
	return (
		<Dialog
			onClose={(event, reason) => {
				if (reason !== "backdropClick" && handleClose) {
					handleClose();
				}
			}}
			aria-labelledby='add-new-shift'
			open={open}
			PaperProps={{ sx: { maxWidth: "900px" } }}
			fullWidth
		>
				<DialogWrapper dialogTitle={isShiftSwap ? t("scheduler_worker-request") : t("scheduler_create-shift")}
					contentStyles={{ padding: "0", overflow: "hidden" }}
					dialogContent={
						<NewShiftDialogForm
							draftShiftDate={draftShiftDate}
							handleClose={handleClose}
							isShiftSwap={isShiftSwap}
							requestComponent={requestComponent}
							isShiftCoverage={isShiftCoverage}
						/>
					}
				/>
		</Dialog>
	);
};

export default NewShiftDialog;
